import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import {
  BackNavigable,
  BackNavigationService,
  showRequestErrors } from '@softline/application';
import { DateService, Store } from '@softline/core';
import { Observable } from 'rxjs';
import { SOFTLINE_FEATURE_COUPON_DAILY_BALANCE } from '../../coupon-app.shared';
import { DailyBalance } from '../../data/daily-balance';
import { DailyBalanceStore } from '../../store/daily-balance.store';

import { LoadingSpinnerComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'lib-daily-balance',
  imports: [CommonModule,
    LoadingSpinnerComponent,
    TranslatePipe],
  templateUrl: './daily-balance.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./daily-balance.component.css'] })
export class DailyBalanceComponent implements OnInit, OnDestroy, BackNavigable {
  private readonly store = inject(Store);
  private readonly router = inject(Router);
  private readonly dateService = inject(DateService);
  private readonly backNavigationService = inject(BackNavigationService);

  loading$: Observable<boolean> = this.store.observe(
    SOFTLINE_FEATURE_COUPON_DAILY_BALANCE,
    DailyBalanceStore.getters.loading
  );

  dailyBalance$: Observable<DailyBalance> = this.store.observe(
    SOFTLINE_FEATURE_COUPON_DAILY_BALANCE,
    DailyBalanceStore.getters.data
  );

  async ngOnInit(): Promise<void> {
    this.backNavigationService.set(this);
    try {
      await this.store.dispatch(
        SOFTLINE_FEATURE_COUPON_DAILY_BALANCE,
        DailyBalanceStore.actions.getDailyBalance,
        { date: this.dateService.now() } //todo: test
      );
    } catch (e) {
      showRequestErrors(this.store, e);
    }
  }

  ngOnDestroy(): void {
    this.backNavigationService.set(undefined);
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/gutscheinkarten']);
  }
}
